<template>
  <div id="Conversion">
    <Head/>
    <div class="conversion">
      <div class="Main">
        <div class="cNav">
          <div class="cNTop">
            <img src="../assets/Hotspot/00.png" />信息公告
          </div>
          <ul>
            <li class="active">应用及转化情况</li>
            <li>
              <ul>
                <li>不同应用状态成果分布</li>
                <li>未应用或停用原因</li>
                <li>不同地区成果产业化应用</li>
                <li>不同行业成果产业化应用</li>
                <li>不同类型单位成果产业化应用</li>
              </ul>
            </li>
            <li class="active">转移转化状态</li>
            <li>
              <ul>
                <li>应用效果</li>
                <li>转移途径</li>
                <li>成果转化得到的政府支持</li>
                <li>本单位转化政策支持</li>
                <li>转化的奖励和报酬</li>
                <li>项目研发人员状态</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="cMain">
          <img src="../assets/back/图层 20.png">
        </div>
      </div>
    </div>
    <Foot/>
  </div>
</template>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
export default {
  name: "Conversion",
  components: {
    Head,
    Foot
  }
};
</script>
<style lang="less" scoped>
  #Conversion{
    width: 100%;
    min-width: 1000px;
    .conversion{
      width:  100%;
      padding: 0 1.35rem;
      margin-top: 0.4rem;
      .Main{
        width: 100%;
        display: flex;
        justify-content: space-between;
        
        .cNav{
          margin-top: 0.8rem;
          width: 3.5rem;
          border: 0.01rem solid #ABABAB;
          .cNTop{
            width: 100%;
            height: 0.6rem;
            background: #3F6BC2;
            font-size: 0.2rem;
            display: flex;
            align-items: center;
            color: white;
            >img{
              margin-left: 0.2rem;
              margin-right: 0.2rem;
            }
          }
          >ul{
            width: 100%;
            >li{
              width: 100%;
              font-size: 0.2rem;
              padding: 0.16rem;
              margin-top: 0.05rem;
              &.active{
                background: #84C7FA;
                color: #ffffff;
              }
              li{
                line-height: 2;
                cursor: pointer;
                &.active{
                  color: #84C7FA;
                }
              }
            }
          }
        }
        .cMain{
          position: relative;
          min-height: 9.8rem;
          width: calc(100% - 3.85rem);
          height: 100%;
          border: 0.01rem solid #ABABAB;
         
        }
      }
    }
  }
</style>